import { createAction } from "@reduxjs/toolkit";
import {
  typeSalesFilters,
  typeSlimSalesItem,
} from "model/dashboardSales/dSalesReducer";
import { typePagination, typeRequestPagination } from "../system/constants";

// ---------------------------------------------------------------------------------------------------------------------
// Action creator of set data
export const dSalesSetDataAC = createAction(
  "D_SALES_SET_DATA",
  (dataList: typeSlimSalesItem[]) => ({ payload: { dataList } }),
);

// Action creator of saga set data
export const dSalesSetDataSagaAC = createAction(
  "D_SALES_SET_DATA_SAGA",
  (filters: typeSalesFilters, paginationRequest: typeRequestPagination) => ({
    payload: { filters, paginationRequest },
  }),
);

// ---------------------------------------------------------------------------------------------------------------------
// Action creator of set item data
export const dSalesSetDetailItemAC = createAction(
  "D_SALES_SET_DETAIL_ITEM",
  (detailItemId: string) => ({ payload: detailItemId }),
);
// ---------------------------------------------------------------------------------------------------------------------
// Action creator of set item data
export const dSalesSetDetailItemFromRefundAC = createAction(
  "D_SALES_SET_DETAIL_ITEM_FROM_REFUND",
  (detailItem: any) => ({ payload: detailItem }),
);
// ---------------------------------------------------------------------------------------------------------------------
// Action creator of clear filtersForm
export const dSalesClearFiltersAC = createAction("D_SALES_CLEAR_FILTERS");

// Action creator of set filtersForm
export const dSalesSetFiltersAC = createAction(
  "D_SALES_SET_FILTERS",
  (filtersObject: typeSalesFilters) => ({ payload: filtersObject }),
);

// Action creator of set filtersForm saga
export const dSalesSetFiltersSagaAC = createAction(
  "D_SALES_SET_FILTERS_SAGA",
  (
    filtersObject: typeSalesFilters,
    paginationRequest: typeRequestPagination,
  ) => ({
    payload: { filtersObject, paginationRequest },
  }),
);

// ---------------------------------------------------------------------------------------------------------------------
// Action creator of set checked item
export const dSalesCheckedItemAC = createAction(
  "D_SALES_CHECK_ITEM",
  (itemId: string) => ({ payload: itemId }),
);

// Action creator of checked all items
export const dSalesCheckedAllItemAC = createAction(
  "D_SALES_CHECK_ALL_ITEM",
  (value: boolean) => ({ payload: value }),
);

// ---------------------------------------------------------------------------------------------------------------------
// Action creator of export data
export const dSalesExportDataSagaAC = createAction(
  "D_SALES_EXPORT_DATA_SAGA",
  (filters: typeSalesFilters, lang: string) => ({
    payload: { filters, lang },
  }),
);

// ---------------------------------------------------------------------------------------------------------------------
// Action creator of set pagination
export const dSalesSetPaginationAC = createAction(
  "D_SALES_SET_PAGINATION",
  (pagination: typePagination) => ({ payload: { pagination } }),
);

// Action creator of set itemsForPage in pagination
export const dSalesSetItemsForPageAC = createAction(
  "D_SALES_SET_ITEMS_FOR_PAGE",
  (itemsForPage: number) => ({ payload: { itemsForPage } }),
);

// Action creator of set pageNumber in pagination
export const dSalesSetPageNumberAC = createAction(
  "D_SALES_SET_PAGE_NUMBER",
  (pageNumber: number) => ({ payload: { pageNumber } }),
);

// ---------------------------------------------------------------------------------------------------------------------
// Action creator of export data
export const dSalesSelectedExportDataSagaAC = createAction(
  "D_SALES_SELECTED_EXPORT_DATA_SAGA",
  (salesIds: string[], lang: string) => ({ payload: { salesIds, lang } }),
);
